import { render, staticRenderFns } from "./create_exchangeCashRed.vue?vue&type=template&id=87f6ef96&scoped=true"
import script from "./create_exchangeCashRed.vue?vue&type=script&lang=js"
export * from "./create_exchangeCashRed.vue?vue&type=script&lang=js"
import style0 from "./create_exchangeCashRed.vue?vue&type=style&index=0&id=87f6ef96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87f6ef96",
  null
  
)

export default component.exports